import React, { useState, useEffect, useMemo } from "react";

import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { fetchRoles } from "../../redux/actions/RoleActions";
import { displayDateFormart, isValidArr } from "../../utility/utils";
import EnhancedTable from "../table/Table";
import PageTitle from "../PageTitle";
import PageSearch from "../PageSearch";
import DialogBox from "../../components/dialog-box/DialogBox";
import RoleForm from "./RoleForm";
import Loader from "../../components/loader/Loader";
import { RoleModel } from "../../models/RoleModel";

export type Mode = "add" | "edit";

type iData = {
  id: number;
  name: string;
  description: string;
  level: string;
  createdDate: string;
  // status: string;
};

const RolePage = () => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState<Mode>("add");
  const [editData, setEditData] = useState<RoleModel>();
  const [rootData, setRootData] = useState<iData[]>([]);
  const [filteredData, setFilteredData] = useState<iData[]>([]);

  const allData = useAppSelector((state) => state.role.all_Roles);
  const isRolesFetching = useAppSelector((state) => state.role.isRolesFetching);

  const columns = useMemo(() => {
    return [
      {
        id: "name",
        numeric: false,
        disablePadding: false,
        label: "Name",
      },
      {
        id: "description",
        numeric: false,
        disablePadding: false,
        label: "Description",
      },
      {
        id: "level",
        numeric: false,
        disablePadding: false,
        label: "Level",
      },
      {
        id: "createdDate",
        numeric: false,
        disablePadding: false,
        label: "Created Date",
        width: 150,
      },
      // {
      //   id: "status",
      //   numeric: false,
      //   disablePadding: false,
      //   label: "Status",
      // },
    ];
  }, []);

  //To fetch all roles
  useEffect(() => {
    dispatch(fetchRoles());
  }, [dispatch]);

  useEffect(() => {
    setRootData(() =>
      allData.map((rec) => ({
        id: rec.roleId,
        name: rec.name,
        description: rec.description,
        level: rec.roleLevel,
        createdDate: displayDateFormart(rec.createdDate),
        // status: rec.isActive ? "Active" : "Inactive",
      }))
    );
  }, [allData]);

  // To set filtered data on change root data
  useEffect(() => {
    setFilteredData(rootData);
  }, [rootData]);

  const handleEdit = (id: string | number) => {
    const editRec = allData.find((rec) => rec.roleId === id);
    setMode("edit");
    setEditData(editRec);
    setIsModalOpen(true);
  };

  const createHandler = () => {
    setMode("add");
    setEditData(undefined);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const searchHandler = (searchVal: string): void => {
    setFilteredData(() =>
      searchVal
        ? rootData.filter((info) =>
            Object.values(info).join("").toLowerCase().includes(searchVal)
          )
        : rootData
    );
  };

  return (
    <>
      {!isValidArr(allData) && isRolesFetching ? <Loader /> : null}
      <PageTitle title="Roles" btnText="Add Role" onClick={createHandler} />
      <PageSearch placeholder="Search Roles" searchHandler={searchHandler} />
      <EnhancedTable
        columns={columns}
        data={filteredData}
        handleEdit={handleEdit}
      />
      {isModalOpen && (
        <DialogBox
          isModalOpen={isModalOpen}
          modalTitle={mode === "add" ? "Create Role" : "Edit Role"}
          handleModalClose={handleModalClose}
        >
          <RoleForm
            mode={mode}
            data={editData}
            handleModalClose={handleModalClose}
          />
        </DialogBox>
      )}
    </>
  );
};

export default RolePage;
